import { Smartphone } from 'lucide-react';
import * as React from 'react';

import { Input, type InputProps } from '@/shared/components/ui/input';
import { cn } from '@/shared/lib/cn';
import { toLatinDigits } from '@/shared/utils/formatters';

export interface PhoneInputProps extends Omit<InputProps, 'value' | 'onChange' | 'type'> {
  value: string;
  onChange: (value: string) => void;
}

/**
 * Iranian mobile field. Normalises Persian digits and strips separators on the
 * way in, so form state always holds the bare `09xxxxxxxxx` the API expects
 * and validation never fails on a space the user could not see.
 */
export const PhoneInput = React.forwardRef<HTMLInputElement, PhoneInputProps>(function PhoneInput(
  { value, onChange, className, ...props },
  ref,
) {
  return (
    <Input
      ref={ref}
      value={value}
      onChange={(event) => onChange(toLatinDigits(event.target.value).replace(/[^\d+]/g, ''))}
      type="tel"
      inputMode="tel"
      autoComplete="tel"
      dir="ltr"
      maxLength={13}
      placeholder="09123456789"
      startAdornment={<Smartphone />}
      className={cn('tabular text-start', className)}
      {...props}
    />
  );
});
